import { defineStore } from "pinia";
import { useLoadingState } from "@polargold/pg-frontend-vue";

export const useProductSearchGlobalIsLoadingStore = defineStore("productSearchGlobalIsLoadingStore", () => {
    const {
        isLoading,
        activateLoadingState: setLoadingState,
        deactivateLoadingState: resetLoadingState,
    } = useLoadingState();

    return { isLoading, setLoadingState, resetLoadingState };
});